import classNames from 'classnames';
import React from 'react';
import { descriptionsClasses, Row } from '../../descriptions.styled';
import { TDescriptionsLayout } from '../../descriptions.types';

export interface DescriptionItemProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
  layout?: TDescriptionsLayout;
}

const DescriptionItem: React.FunctionComponent<DescriptionItemProps> = ({
  right,
  left,
  className,
  layout,
}) => {
  if (layout === 'horizontal') {
    return (
      <Row
        className={classNames(
          descriptionsClasses.item,
          descriptionsClasses.itemHorizontal,
          className,
        )}
      >
        <th className={descriptionsClasses.itemLeft} key="label">
          {left}
        </th>
        <td className={descriptionsClasses.itemRight} key="body">
          {right}
        </td>
      </Row>
    );
  }

  return (
    <Row
      className={classNames(descriptionsClasses.item, descriptionsClasses.itemVertical, className)}
    >
      <td className={descriptionsClasses.itemInner} key="body">
        <div className={descriptionsClasses.itemLeft}>{left}</div>
        <div className={descriptionsClasses.itemRight}>{right}</div>
      </td>
    </Row>
  );
};

export default DescriptionItem;
